import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="Contact" />
      <Inquiry />
      <Footer />
    </div>;
}